import { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import api from '@/lib/api';
import { PageSEO } from '@/components/SEO';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const res = await api.get('/site-builder/store-settings');
        setFaqs(res.data?.faq || []);
      } catch (error) {
        console.error('Failed to load FAQs');
      } finally {
        setLoading(false);
      }
    };
    fetchFAQs();
  }, []);

  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="faq-page">
      <PageSEO.faq />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-medium mb-4">FAQ</h1>
        <p className="text-lg text-stone-600 mb-12">
          Frequently asked questions about our products and services.
        </p>

        {loading ? (
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-16 bg-stone-100 rounded animate-pulse" />
            ))}
          </div>
        ) : faqs.length > 0 ? (
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-stone-200 rounded-lg px-6"
              >
                <AccordionTrigger className="text-left hover:no-underline py-4">
                  <span className="font-medium text-stone-900">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-stone-600 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        ) : (
          <div className="text-center py-12 text-stone-500 bg-stone-50 rounded-lg">
            <p>Our FAQ section is coming soon.</p>
            <p className="text-sm mt-2">In the meantime, feel free to contact us with any questions.</p>
          </div>
        )}
      </div>
    </div>
  );
}
